import { Component, Emit, Vue, Prop, Watch } from 'vue-property-decorator';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import { VNode } from 'vue';
import { Upload } from 'ant-design-vue';

const allowExt = '.doc'.split(',');
function allowFile(name: string, accept: string): boolean {
  const exts = (accept || '')
    .toLowerCase()
    .split(',')
    .map(o => o.trim().toLowerCase())
    .filter(o => o.length > 0);
  const ext = getFileExt((name || '').toLowerCase());
  if (!ext) {
    return false;
  }
  return exts.some(o => o === ext);
}
function getFileExt(name: string) {
  name = name || '';
  const pos = name.lastIndexOf('.');
  if (pos > -1) {
    return name.substr(pos);
  }
  return null;
}

/** 上传文件 */
@Component({})
export default class StorageUpload extends Vue {
  @Prop({ default: 'default' }) bucketName?: string;
  @Prop({ default: 'false' }) isPublic?: boolean;
  @Prop({ default: 'true' }) isDragger?: boolean;
  @Prop({ default: 'false' }) disabled?: boolean;
  uploadUrl = '/api/sys_Storage/Upload';
  fileList = [];
  showUploadList = true;
  uploadSuccessFiles: any[] = [];

  @State(s => s.user.token)
  token: string;

  getFormData() {
    return { bucketName: this.bucketName, IsPublicAccess: this.isPublic };
  }
  getHeaer() {
    return { Authorization: 'Bearer ' + this.token };
  }
  dragover() {
    console.log('dragover');
  }
  beforeUpload({ name }: any, filelist: string[]) {
    const allow = allowFile(name, this.$attrs.accept);
    if (!allow) {
      this.$error({ content: `只允许上传文件类型：${this.$attrs.accept}` });
    }
    return allow;
  }
  handleChange(info: any) {
    this.showUploadList = true;
    this.fileList = info.fileList;

    if (info.file.response && info.file.response.success) {
      this.uploadSuccessFiles.push(info.file.response.data[0]);
    }

    if (info.file.status === 'done') {
      if (this.uploadSuccessFiles.length === info.fileList.length) {
        console.log('done', this.uploadSuccessFiles);
        this.$message.success(`文件上传成功`);
        //  this.$message.success(`${info.file.name} 文件上传成功`);
        this.$emit('uploadSuccess', this.uploadSuccessFiles);
        this.uploadSuccessFiles = [];
        this.showUploadList = false;
        this.fileList = [];
      }
    } else if (info.file.status === 'error') {
      this.$message.success(`文件上传失败，请重新上传！`);
      this.uploadSuccessFiles = [];
      this.showUploadList = false;
      this.fileList = [];
    }
  }

  render() {
    if (this.isDragger) {
      return (
        <div>
          <a-upload-dragger
            dragover={this.dragover}
            class="c2upload"
            name="files"
            action={this.uploadUrl}
            data={this.getFormData()}
            beforeUpload={this.beforeUpload}
            multiple={true}
            headers={this.getHeaer()}
            on-change={this.handleChange}
            fileList={this.fileList}
            showUploadList={this.showUploadList}
            {...{ props: this.$attrs }}
            {...{ on: this.$listeners }}
          >
            {this.$slots.default || (
              <a-col>
                <p class="ant-upload-drag-icon">
                  <a-icon type="inbox" />
                </p>
                <p class="ant-upload-text" style="font-size:15px;">
                  选择或将文件拖到这里
                </p>
              </a-col>
            )}
          </a-upload-dragger>
        </div>
      );
    } else {
      return (
        <a-upload
          name="files"
          action={this.uploadUrl}
          data={this.getFormData()}
          beforeUpload={this.beforeUpload}
          headers={this.getHeaer()}
          on-change={this.handleChange}
          fileList={this.fileList}
          showUploadList={this.showUploadList}
          {...{ props: this.$attrs }}
          {...{ on: this.$listeners }}
        >
          {
            <a-button size="small" disabled={this.disabled}>
              <a-icon type="upload" />
              上传照片
            </a-button>
          }
        </a-upload>
      );
    }
  }
}
